import React, { Component } from 'react';
import AdminFilteredContentList from './Admin_FilteredContentList';

class EnemyList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEnemy: "",

        };
    }


    handleFilterChange = (event) => {

        let value = event.target.value;


        this.setState({ selectedEnemy: value });
    };

    render() {
        const {
            enemies,
            filter,
            onSelectEnemy,
            onNewEnemy,
            regions,
        } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewEnemy}>Create New Enemy</button>

                <AdminFilteredContentList
                    context={{ regions }}
                    filter={filter}
                    getKey={(item, index) => item.id || item.Id || index}
                    kind="enemy"
                    records={enemies}
                    renderRecord={item => (
                        <button
                            className="listElement"
                            onClick={() => onSelectEnemy(item)}
                            type="button"
                        >
                            {item.name ?? item.Name}
                        </button>
                    )}
                />


            </div>
        );
    }
}

export default EnemyList;
